<template>
  <v-container fluid style="margin-top: 25%;">
    <v-layout row>
      <v-flex xs12 style="text-align: center;">
        <v-icon color="red lighten-1" size="70px">error_outline</v-icon>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <h1
          class="subheading grey--text text--darken-1"
          style="text-align: center; margin-top: 30px;"
        >{{ message }}</h1>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default:
        "Lo sientimos, tu internet anda un poco lento, verifica la conexión y vuelte a intentar por favor."
    }
  }
};
</script>
